import React from "react";
import { Helmet } from "react-helmet";
import { LazyLoadImage } from "react-lazy-load-image-component";
import MultiLingualContent from "../../../languages/MultiLingualContent";
import nevuvit1 from "../../../assets/images/nevuvit1.jpeg";
import BackButton from "../../backButton";

const Nevuvit = () => {
  return (
    <div className="inner-section" id="nevuvit">
      <Helmet>
        <title>פטרידע - הפטריה נבובית</title>
        <meta
          name="description"
          content="הפטריה נבובית - Macrocystidia: תאור, זיהוי ותמונות"
        />
      </Helmet>
      <BackButton path="/#types-and-species" />
      <h2>
        <MultiLingualContent contentID="nevuvit" />
      </h2>
      <>
        <div className="informationText">
          <p>
            <MultiLingualContent contentID="nevuvitText1" />
          </p>
          <p>
            <MultiLingualContent contentID="nevuvitText2" />
          </p>
          <br />
          <p>
            <b>
              <MultiLingualContent contentID="nevuvitText3Bold" />
            </b>
          </p>
          <p>
            <MultiLingualContent contentID="nevuvitText4" />
          </p>
          <div className="informationImages">
            <div className="imgWrapper">
              <LazyLoadImage src={nevuvit1} alt="נבובית" />
              <p>
                <MultiLingualContent contentID="nevuvitImg1" />
              </p>
            </div>
          </div>
          <p>
            <MultiLingualContent contentID="nevuvitText5" />
          </p>
          <p>
            <b>
              <MultiLingualContent contentID="nevuvitText6Bold" />
            </b>
            <MultiLingualContent contentID="nevuvitText7" />
          </p>
          <p>
            <b>
              <MultiLingualContent contentID="nevuvitText8Bold" />
            </b>
            <MultiLingualContent contentID="nevuvitText9" />
          </p>
        </div>
      </>
    </div>
  );
};

export default Nevuvit;
